import { RegionOptionsStrings } from 'enums/RegionOptions'
import { RegionOptions } from 'enums'

// eslint-disable-next-line import/prefer-default-export
export const getCountryFilterKey = (region: RegionOptionsStrings) => {
  switch (region) {
    case RegionOptions.WORLD:
      return undefined
    case RegionOptions.SOUTH_AMERICA:
      return 'Continent/#SouthAmerica'
    case RegionOptions.CENTRAL_AMERICA:
      return 'Continent/#CentralAmerica'
    case RegionOptions.EUROPE:
      return 'Continent/#Europe'
    case RegionOptions.AFRICA:
      return 'Continent/#Africa'
    case RegionOptions.ASIA:
      return 'Continent/#Asia'
    case RegionOptions.OCEANIA:
      return 'Continent/#Oceania'
    case RegionOptions.CARIBBEAN:
      return 'Continent/#Caribbean'
    case RegionOptions.NORTH_AMERICA:
      return 'Continent/#NorthernAmerica'
    case RegionOptions.US:
      return '#6252001'
    case RegionOptions.CANADA:
      return '#6251999'
    case RegionOptions.MEXICO:
      return '#3996063'
    case RegionOptions.JAPAN:
      return '#1861060'
    case RegionOptions.BRAZIL:
      return '#3469034'
    case RegionOptions.UNITED_KINGDOM:
      return '#2635167'
    case RegionOptions.GERMANY:
      return '#2921044'
    case RegionOptions.FRANCE:
      return '#3017382'
    case RegionOptions.POLAND:
      return '#798544'
    case RegionOptions.SPAIN:
      return '#2510769'
    case RegionOptions.ITALY:
      return '#3175395'
    case RegionOptions.RUSSIA:
      return '#2017370'
    case RegionOptions.TURKEY:
      return '#298795'
    case RegionOptions.INDIA:
      return '#1269750'
    case RegionOptions.CHINA:
      return '#1814991'
    case RegionOptions.SOUTH_KOREA:
      return '#1835841'
    case RegionOptions.INDONESIA:
      return '#1643084'
    case RegionOptions.THAILAND:
      return '#1605651'
    case RegionOptions.MALAYSIA:
      return '#1733045'
    case RegionOptions.AUSTRALIA:
      return '#2077456'
    case RegionOptions.NEW_ZEALAND:
      return '#2186224'
    default:
      throw new Error(`no filter key for region: ${region}}`)
  }
}
